import { createContext, useContext } from 'react';

/**
 * Описание тенанта, доступного текущему админу (из /auth/admin/me).
 */
export interface TenantSummary {
  slug: string;
  name: string;
  logoUrl?: string | null;
}

export interface TenantContextValue {
  /** Активный tenant (или null в однотенантном режиме). */
  activeTenant: TenantSummary | null;
  /** Все тенанты, доступные админу. В однотенантном режиме — пустой массив. */
  tenants: TenantSummary[];
  /** Переключатель виден только когда тенантов больше одного. */
  hasMultipleTenants: boolean;
  /** Переключение активного тенанта: switch-tenant на backend → reload. */
  switchTenant: (slug: string) => Promise<void>;
  /** Идёт переключение тенанта. */
  isSwitching: boolean;
}

export const TenantContext = createContext<TenantContextValue | undefined>(
  undefined,
);

/**
 * Доступ к tenant-контексту. Безопасен вне провайдера: возвращает
 * однотенантный дефолт (как до мультитенантности), чтобы компоненты,
 * отрендеренные до загрузки /me, не падали.
 */
export function useTenant(): TenantContextValue {
  const context = useContext(TenantContext);
  if (context === undefined) {
    return {
      activeTenant: null,
      tenants: [],
      hasMultipleTenants: false,
      switchTenant: async () => undefined,
      isSwitching: false,
    };
  }
  return context;
}
